import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#debt-management-advisor-v2-app', App);
